import { render, staticRenderFns } from "./PurchaseStocks.vue?vue&type=template&id=53eedafb&"
import script from "./PurchaseStocks.vue?vue&type=script&lang=js&"
export * from "./PurchaseStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports